import { AssemblerManagementOption } from '../enums/AssemblerManagementOption';
import { OrderAssemblyState } from '../enums/OrderAssemblyState';

export const Mapper = {

  getOrderAssemblyStateFromAssemblerManagementOption: (assemblerManagementOption?: AssemblerManagementOption|null): OrderAssemblyState|undefined|null => {
    if (!assemblerManagementOption) return null;
    const mapping = {
      [AssemblerManagementOption.InformReceipt]: OrderAssemblyState.PedidoRecebidoMontagem,
      [AssemblerManagementOption.InformAssemblyStart]: OrderAssemblyState.PedidoIniciadoMontagem,
      [AssemblerManagementOption.InformCompletedAssembly]: OrderAssemblyState.PedidoConcluidoMontagem,
      [AssemblerManagementOption.InformSendToStore]: OrderAssemblyState.PedidoEnviadoLoja,
    }
    return (mapping as any)[assemblerManagementOption];
  }

}